import React, { useState, useEffect } from 'react';
import './SingleRehabPage.css';
// import {details} from './data';
import Parse from 'parse';
import Navbar from '../layouts/navbar';
// import image1 from '../../../public/assests/images/rehab1.jpg';
import image1 from '../../assets/img/rehab1.jpg';


// state = {
//     rehabs: details,
//     selected: { id: 1, image1: "/assests/images/rehab1.jpg", image2: "/assests/images/rehab1.jpg", image3: "/assests/images/rehab1.jpg", heading: "Jan Kalyan Nasha Mukti Kendra", description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum." }
// }
const icolor={
    color:"#6cb5fd"
}

const IRehabPage = (props) => {

    useEffect(() => {

        const Rehab = Parse.Object.extend("Rehab");
        const query = new Parse.Query(Rehab);
        const id = props.match.params.id;
        query.get(id)
            .then((rehab) => {
                setName(rehab.get("name"));
                setEmail(rehab.get("email"));
                setAbout(rehab.get("about"));
                setLocation(rehab.get("location"));
                setPhno(rehab.get("phno"));
                setReview1(rehab.get("review1"));
                setReview2(rehab.get("review2"));
                setReview3(rehab.get("review3"));


            }, (error) => {
                console.log(error);
            })

    }, [])


    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [about, setAbout] = useState('');
    const [location, setLocation] = useState('');
    const [phno, setPhno] = useState('');
    const [review1, setReview1] = useState('');
    const [review2, setReview2] = useState('');
    const [review3, setReview3] = useState('');


    
    return (
        <div>
            <Navbar head="Rehabilation centre" />
            <div className="container" style={{ fontFamily: "'Open Sans',sans-serif", marginTop: "50px" }}>
                <div className="row justify-content-center">
                    <div className="col-12 col-lg-8">
                        <div id="imgcarousel" className="carousel slide" data-ride="carousel">
                            <ol className="carousel-indicators">
                                <li data-target="#imgcarousel" data-slide-to="0" className="active"></li>
                                <li data-target="#imgcarousel" data-slide-to="1"></li>
                                <li data-target="#imgcarousel" data-slide-to="2"></li>
                            </ol>
                            <div className="carousel-inner">
                                <div className="carousel-item active">
                                    <img className="img-fluid" src={image1} alt="">
                                    </img>

                                </div>
                                <div className="carousel-item">
                                    <img className="img-fluid" src={image1} alt="">
                                    </img>

                                </div>
                                <div className="carousel-item">
                                    <img className="img-fluid" src={image1} alt="">
                                    </img>

                                </div>
                            </div>
                            <a className="carousel-control-prev" href="#imgcarousel" role="button" data-slide="prev">
                            <i className="fas fa-angle-left fa-3x"></i>
                                <span className="sr-only">Previous</span>
                            </a>
                            <a className="carousel-control-next" href="#imgcarousel" role="button" data-slide="next">
                            <i className="fas fa-angle-right fa-3x"></i>
                                <span className="sr-only">Next</span>
                            </a>
                        </div>
                    </div>
                </div>
                <div className="row justify-content-center">
                    <div className="col-12 col-lg-10">
                        <h1 className="text-left bottom">
                            {name}
                        </h1>
                        {/* <p style={{fontSize:"1.5rem"}}> */}
                        <div style={{ fontSize: "17px" }}>

                            {/* {this.state.selected.description} */}

                            {/* {about} */}
                            <p><strong>Location</strong> : {location}</p>
                            <p><strong>Email </strong>: {email}</p>
                            <p><strong >Contact Number</strong> :{phno}</p>
                        </div>
                        <hr />
                    </div>
                </div>
                <div className="row justify-content-center my-4" style={{ minHeight: "80vh" }}>
                    <div className="col-12 col-lg-6">
                        <div className="carousel slide" id="reviewcarousel" data-ride="carousel">
                            <ol className="carousel-indicators">
                                <li data-target="#reviewcarousel" data-slide-to="0" className="active"></li>
                                <li data-target="#reviewcarousel" data-slide-to="1"></li>
                                <li data-target="#reviewcarousel" data-slide-to="2"></li>
                            </ol>
                            <div className="carousel-inner">
                                <div className="carousel-item active">
                                    <div className="card" style={{ minHeight: "80vh" }} >
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-4">
                                                    <div className="card-subtitle text-muted lead">Top Reviews</div>
                                                </div>
                                                {/* <div className="col-4 ml-auto">
                                                    <span className="star fas fa-star checked"></span>
                                                    <span className="star fas fa-star checked"></span>
                                                    <span className="star fas fa-star checked"></span>
                                                    <span className="star fas fa-star"></span>
                                                    <span className="star fas fa-star"></span>
                                                </div> */}
                                            </div>
                                            <div className="row justify-content-center">
                                                <div className="col-auto">
                                                    <span className="fas fa-user checked"></span>
                                                </div>
                                            </div>
                                            <div className="row justify-content center">
                                                <div className="col-12 text-center">

                                                    {/* <p className="checked">Ansh Arora</p> */}

                                                </div>
                                            </div>
                                            <div className="row justify-content-center">
                                                <div className="col-10">
                                                    <p className="lead">{review1}</p>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <Review review={review2} />
                                <Review review={review3} />
                            </div>
                            <a class="carousel-control-prev" href="#reviewcarousel" role="button" data-slide="prev">
                            <i class="fas fa-angle-left fa-3x" style={icolor}></i>
                                <span class="sr-only">Previous</span>
                            </a>
                            <a class="carousel-control-next" href="#reviewcarousel" role="button" data-slide="next">
                            <i class="fas fa-angle-right fa-3x" style={icolor}></i>
                                <span class="sr-only">Next</span>
                            </a>

                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
}

const Review = (props) => {
    if (props.review !== '') {
        return (
            <div className="carousel-item">
                <div className="card" style={{ minHeight: "80vh" }}>
                    <div className="card-body">
                        <div className="row">
                            <div className="col-4">
                                <div className="card-subtitle text-muted lead">Top Reviews</div>
                            </div>
                            {/* <div className="col-4 ml-auto">
                                <span className="star fas fa-star checked"></span>
                                <span className="star fas fa-star checked"></span>
                                <span className="star fas fa-star checked"></span>
                                <span className="star fas fa-star"></span>
                                <span className="star fas fa-star"></span>
                            </div> */}
                        </div>
                        <div className="row justify-content-center">
                            <div className="col-auto">
                                <span className="fas fa-user checked"></span>
                            </div>
                        </div>
                        <div className="row justify-content center">
                            <div className="col-12 text-center">

                                {/* <p className="checked">Ansh Arora</p> */}

                            </div>
                        </div>
                        <div className="row justify-content-center">
                            <div className="col-10">
                                <p className="lead">{props.review}</p>
                            </div>
                        </div>
                        <div className="row justify-content-end">
                            <div className="col-auto">
                                <button className="btn text-white"><span class="fas fa-plus-circle mr-2"></span>Add Review</button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

        )
    }
    else {
        return (
            <div className="carousel-item">
                <div className="card" style={{ minHeight: "80vh" }}>
                    <div className="card-body">




                        <div className="row justify-content-center">
                            <div className="col-10">
                                <p className="lead">No More review yet</p>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

        )
    }
}


export default IRehabPage;

